import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ContactService } from '../../../_services/contact.service';

@Component({
  selector: 'app-contact-picker',
  templateUrl: './contact_picker.component.html',
  styleUrls: ['./contact_picker.component.css']
  //styleUrls: ['./contact-picker.component.css']
})
export class ContactPickerComponent implements OnInit {
  contacts: any[] = [];
  filteredContacts: any[] = [];
  selectedContacts: any[] = [];
  searchTerm: string = '';
  selectedFilter: string = 'all';
  loading: boolean = false;
  error: string = '';
  
  // Pagination
  currentPage: number = 1;
  pageSize: number = 25;

  constructor(
    public dialogRef: MatDialogRef<ContactPickerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private contactService: ContactService
  ) {}

  ngOnInit() {
    console.log('ContactPickerComponent ngOnInit called');
    console.log('Initial state:', {
      loading: this.loading,
      error: this.error,
      contacts: this.contacts.length,
      filteredContacts: this.filteredContacts.length,
      currentPage: this.currentPage,
      pageSize: this.pageSize
    });
    this.loadContacts();
  }

  loadContacts() {
    console.log('loadContacts called');
    this.loading = true;
    this.error = '';
    console.log('Loading set to true, error cleared');
    
    this.contactService.getAllContacts().subscribe({
      next: (response) => {
        console.log('API Response received:', response);
        this.contacts = this.mapContactsFromApi(response);
        console.log('Contacts after mapping:', this.contacts);
        this.filteredContacts = [...this.contacts];
        console.log('Filtered contacts set:', this.filteredContacts);
        this.currentPage = 1; // Reset to first page when loading new data
        this.loading = false;
        console.log('Loading set to false');
      },
      error: (error) => {
        console.error('Fehler beim Laden der Kontakte:', error);
        this.error = 'Fehler beim Laden der Kontakte';
        this.loading = false;
        console.log('Error occurred, loading set to false, error:', this.error);
        // Fallback zu Mock-Daten
        this.loadMockContacts();
      }
    });
  }

  private mapContactsFromApi(apiContacts: any[]): any[] {
    console.log('mapContactsFromApi called with:', apiContacts);
    if (!Array.isArray(apiContacts)) {
      console.error('API contacts is not an array:', apiContacts);
      return [];
    }
    
    const mapped = apiContacts.map(contact => ({
      id: contact.id,
      name: this.buildContactName(contact),
      email: contact.email || '',
      isFavorite: false, // Kann später aus der API kommen
      lastUsed: contact.updated_at || contact.created_at || new Date().toISOString()
    }));
    
    console.log('Mapped contacts:', mapped);
    return mapped;
  }

  private buildContactName(contact: any): string {
    console.log('buildContactName called with:', contact);
    const parts = [];
    if (contact.first_name) parts.push(contact.first_name);
    if (contact.last_name) parts.push(contact.last_name);
    if (parts.length === 0 && contact.company) parts.push(contact.company);
    const name = parts.join(' ') || 'Unbekannter Kontakt';
    console.log('Built name:', name);
    return name;
  }

  private loadMockContacts() {
    console.log('Loading mock contacts...');
    this.contacts = [
      { id: 1, name: 'Max Mustermann', email: 'max@example.com', isFavorite: true, lastUsed: new Date('2024-01-15') },
      { id: 2, name: 'Anna Meier', email: 'anna@example.com', isFavorite: false, lastUsed: new Date('2024-01-10') },
      { id: 3, name: 'Peter Schmidt', email: 'peter@example.com', isFavorite: true, lastUsed: new Date('2024-01-12') },
      { id: 4, name: 'Maria Weber', email: 'maria@example.com', isFavorite: false, lastUsed: new Date('2024-01-08') },
      { id: 5, name: 'Thomas Müller', email: 'thomas@example.com', isFavorite: true, lastUsed: new Date('2024-01-14') },
      { id: 6, name: 'Lisa Fischer', email: 'lisa@example.com', isFavorite: false, lastUsed: new Date('2024-01-05') },
      { id: 7, name: 'Michael Wagner', email: 'michael@example.com', isFavorite: true, lastUsed: new Date('2024-01-13') },
      { id: 8, name: 'Sarah Becker', email: 'sarah@example.com', isFavorite: false, lastUsed: new Date('2024-01-09') }
    ];
    this.filteredContacts = [...this.contacts];
    this.currentPage = 1; // Reset to first page when loading mock data
    console.log('Mock contacts loaded:', this.contacts.length, 'contacts');
    console.log('Filtered contacts set:', this.filteredContacts.length, 'contacts');
  }

  onSearchInput(event: any) {
    console.log('Search input changed:', event.target.value);
    this.searchTerm = event.target.value;
    this.filterContacts();
  }

  onFilterChange(event: any) {
    console.log('Filter changed:', event.target.value);
    this.selectedFilter = event.target.value;
    this.filterContacts();
  }

  filterContacts() {
    console.log('filterContacts called');
    let filtered = [...this.contacts];
    console.log('Starting with contacts:', this.contacts.length);

    // Apply search filter
    if (this.searchTerm) {
      const searchLower = this.searchTerm.toLowerCase();
      filtered = filtered.filter(contact => 
        contact.name.toLowerCase().includes(searchLower) || 
        contact.email.toLowerCase().includes(searchLower)
      );
      console.log('After search filter:', filtered.length);
    }

    // Apply category filter
    switch (this.selectedFilter) {
      case 'recent':
        filtered = filtered.sort((a, b) => new Date(b.lastUsed).getTime() - new Date(a.lastUsed).getTime()).slice(0, 10);
        break;
      case 'favorites':
        filtered = filtered.filter(contact => contact.isFavorite);
        break;
      case 'all':
      default:
        // Keep all contacts
        break;
    }

    this.filteredContacts = filtered;
    this.currentPage = 1; // Reset to first page when filtering
    console.log('Final filtered contacts:', this.filteredContacts.length);
  }

  toggleContactSelection(contact: any) {
    console.log('toggleContactSelection called with:', contact);
    const index = this.selectedContacts.findIndex(c => c.email === contact.email);
    console.log('Found index:', index);
    
    if (index > -1) {
      this.selectedContacts.splice(index, 1);
      console.log('Contact removed from selection');
    } else {
      this.selectedContacts.push(contact);
      console.log('Contact added to selection');
    }
    console.log('Selected contacts after toggle:', this.selectedContacts.length);
  }

  isContactSelected(contact: any): boolean {
    const isSelected = this.selectedContacts.some(c => c.email === contact.email);
    console.log('isContactSelected called for:', contact.email, 'result:', isSelected);
    return isSelected;
  }

  removeSelectedContact(index: number) {
    console.log('removeSelectedContact called with index:', index);
    this.selectedContacts.splice(index, 1);
    console.log('Selected contacts after removal:', this.selectedContacts.length);
  }

  confirmSelection() {
    console.log('confirmSelection called with:', this.selectedContacts.length, 'contacts');
    // Return all selected contacts
    this.dialogRef.close(this.selectedContacts);
  }

  cancel() {
    console.log('cancel called');
    this.dialogRef.close();
  }

  // Pagination Methods
  getPaginatedContacts(): any[] {
    const startIndex = (this.currentPage - 1) * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    const result = this.filteredContacts.slice(startIndex, endIndex);
    console.log('getPaginatedContacts called:', {
      currentPage: this.currentPage,
      pageSize: this.pageSize,
      startIndex: startIndex,
      endIndex: endIndex,
      filteredContactsLength: this.filteredContacts.length,
      resultLength: result.length
    });
    return result;
  }

  getTotalPages(): number {
    const totalPages = Math.ceil(this.filteredContacts.length / this.pageSize);
    console.log('getTotalPages called:', {
      filteredContactsLength: this.filteredContacts.length,
      pageSize: this.pageSize,
      totalPages: totalPages
    });
    return totalPages;
  }

  goToPage(page: number): void {
    console.log('goToPage called with:', page);
    const totalPages = this.getTotalPages();
    console.log('Total pages:', totalPages);
    if (page >= 1 && page <= totalPages) {
      this.currentPage = page;
      console.log('Current page set to:', this.currentPage);
    } else {
      console.log('Invalid page number:', page);
    }
  }

  onPageSizeChange(): void {
    console.log('Page size changed to:', this.pageSize);
    this.currentPage = 1; // Reset to first page when changing page size
    console.log('Current page reset to:', this.currentPage);
  }
}
